<div class="menu-grid-container">
    <div class="glass-blurred-background menu-box center-content" (click)="openMyTeamPage()">
        <img class="block-image svg-white" src="./assets/imgs/squadre.svg">
        <h2 class="text-center">MIA <br>
            <div class="wrap-text">SQUADRA</div>
        </h2>
    </div>
    <div class="glass-blurred-background menu-box center-content" (click)="openPage('/clients')">
        <img class="block-image svg-white" src="./assets/imgs/clienti.svg">
        <h2 class="text-center">MIEI <br>
            <div class="wrap-text">CLIENTI</div>
        </h2>
    </div>
    <div class="glass-blurred-background menu-box center-content" (click)="openPage('/my-investments')">
        <img class="block-image svg-white" src="./assets/imgs/investimenti.svg">
        <h2 class="text-center">MIO <br>
            <div class="wrap-text">INVESTIMENTO</div>
        </h2>
    </div>
    <div class="glass-blurred-background menu-box center-content" (click)="openPage('/my-bonuses')">
        <img class="block-image svg-white" src="./assets/imgs/bonus.svg">
        <h2 class="text-center">MIEI <br>
            <div class="wrap-text">BONUS</div>
        </h2>
    </div>
</div>

<!--

<ion-row class="dashboard-row">
  
  <ion-col size="6" [ngClass]="cssClass" class="dashboard-col" (click)="openMyTeamPage()">
    <div class="dash-widget">
      <div class="">
        <span class="ds-dashicon squadre"></span>
      </div>
      <div class="dash-widget-info">
        <p class="dash-text">La mia squadra</p>
      </div>
    </div>
  </ion-col>
  
  <ion-col size="6" [ngClass]="cssClass" class="dashboard-col" (click)="openPage('/clients')">
    <div class="dash-widget">
      <div class="">
        <span class="ds-dashicon clienti"></span>
      </div>
      <div class="dash-widget-info">
        <p class="dash-text">I miei cienti</p> 
      </div>
    </div>
  </ion-col>

  <ion-col size="6" [ngClass]="cssClass" class="dashboard-col" (click)="openPage('/my-investments')">
    <div class="dash-widget">
      <div class="">
        <span class="ds-dashicon investimenti"></span>
      </div>
      <div class="dash-widget-info">
        <p class="dash-text">I miei investimenti</p>
      </div>
    </div>
  </ion-col>

  <ion-col size="6" [ngClass]="cssClass" class="dashboard-col" (click)="openPage('/my-bonuses')">
    <div class="dash-widget">
      <div class="">
        <span class="ds-dashicon bonus"></span>
      </div>
      <div class="dash-widget-info">
        <p class="dash-text">I miei Bonus</p>
      </div>
    </div>
  </ion-col>
  
</ion-row> -->
